module.exports = __webpack_public_path__ + "media/images/dcs-logo-light-38f1bc9719b1e78c878fbe72fe45a479.png";